<template>
    <div id="AutomationTitle">
        <div class="block-title-container d-flex flex-row justify-content-center align-items-center">
            <IconButton :on-click="goBack">
                <span class="material-icons cb-back-button"> chevron_left </span>
            </IconButton>
            <div class="title-content">
                <input
                    ref="editStoryName"
                    :placeholder="$t('chatbotv2.typeAutomationTitle')"
                    :value="name"
                    @input="name = $event.target.value"
                    @blur="updateName()"
                    class="title-input"
                />
                <div class="description-container" @click="openDescriptionEditor">
                    <span v-if="description" class="description-text">{{ description }}</span>
                    <span v-else class="description-placeholder">{{ $t('automation.addDescription') }}</span>
                    <span class="material-icons edit-icon">edit</span>
                </div>
            </div>
        </div>

        <a-modal
            :title="$t('automation.editDescription')"
            v-model="descriptionModalVisible"
            :footer="null"
            :width="500"
        >
            <div class="description-edit-modal">
                <a-textarea
                    v-model="descriptionEdit"
                    :placeholder="$t('automation.descriptionPlaceholder')"
                    :auto-size="{ minRows: 3, maxRows: 8 }"
                />
                <div class="modal-actions">
                    <a-button @click="descriptionModalVisible = false">{{ $t('common.cancel') }}</a-button>
                    <a-button type="primary" @click="saveDescription">{{ $t('common.save') }}</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import IconButton from "../../../../Settings/components/IconButton.vue";
import { AUTOMATION_API } from "../../../../../../api/automation";

export default {
    name: "AutomationTitle",
    components: { IconButton },
    props: [],
    data() {
        return {
            name: "",
            description: "",
            descriptionEdit: "",
            descriptionModalVisible: false,
        };
    },
    computed: {
        ...mapState({
            automation: (state) => state.automation.current,
            voiceAgentChannel: (state) => state.channel.channels.find((x) => x.type === "retell"),
        }),
    },
    created() {
        this.name = this.automation.name;
        this.description = this.automation.description || "";
    },
    watch: {
        'automation.description': function(newVal) {
            this.description = newVal || "";
        },
    },
    methods: {
        ...mapActions({
            changeAutomationName: "automation/changeAutomationName",
        }),
        goBack() {
            if (window.sessionStorage.getItem("automation-selected-module") === "calendar") {
                console.log("goBack to calendar /calendar/automations");
                this.$router.push("/reservation/automations");
                window.sessionStorage.removeItem("automation-selected-module");
            } else if (window.sessionStorage.getItem("automation-selected-module") === "ticket") {
                console.log("goBack to ticket /ticket?tab=ticket-automations");
                this.$router.push("/ticket?tab=ticket-automations");
                window.sessionStorage.removeItem("automation-selected-module");
            } else if (window.sessionStorage.getItem("automation-selected-module") === "task") {
                console.log("goBack to tasks /tasks?type=automation");
                this.$router.push("/tasks?type=automation");
                window.sessionStorage.removeItem("automation-selected-module");
            } else if (window.sessionStorage.getItem("automation-selected-module") === "chat") {
                console.log("goBack to chat /chat?tab=automations");
                this.$router.push("/chat?tab=automations");
                window.sessionStorage.removeItem("automation-selected-module");
            } else if (window.sessionStorage.getItem("automation-selected-module") === "voiceagent") {
                console.log(
                    "goBack to voiceagent /integrations/voice-agent/67f7a7e174aa87962b00f997/dashboard/automations?tab=automations"
                );

                //ex: integrations/voice-agent/67f7a7e174aa87962b00f997/dashboard/automations?tab=automations
                this.$router.push(
                    `/integrations/voice-agent/${this.voiceAgentChannel._id}/dashboard/automations?tab=automations`
                );
                window.sessionStorage.removeItem("automation-selected-module");
            } else {
                this.$router.push("/automations/all-automations");
            }
        },
        updateName() {
            this.changeAutomationName(this.name).then(() => {
                this.$message.success("Automation name updated");
            });
        },
        openDescriptionEditor() {
            this.descriptionEdit = this.description;
            this.descriptionModalVisible = true;
        },
        async saveDescription() {
            try {
                await AUTOMATION_API.updateAutomationSingleKey(
                    this.automation._id,
                    'description',
                    this.descriptionEdit
                );
                this.description = this.descriptionEdit;
                this.descriptionModalVisible = false;
                this.$message.success(this.$t('automation.descriptionSaved'));
                this.$store.dispatch("automation/syncAutomations");
            } catch (e) {
                this.$message.error(this.$t('automation.descriptionSaveError'));
            }
        },
    },
};
</script>

<style lang="scss">
#AutomationTitle {
    .cb-back-button {
        font-size: 40px !important;
    }

    .block-title-container {
        gap: 10px;

        .title-content {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0;

            .title-input {
                background: none;
                border: 0;
                font-size: 22px;
                font-weight: 600;
                line-height: 28px;
                width: 100%;
                font-family: Source Sans Pro, sans-serif;
                cursor: context-menu;
            }

            .description-container {
                display: flex;
                align-items: center;
                gap: 6px;
                cursor: pointer;
                padding: 4px 0;
                margin-top: 2px;

                &:hover {
                    .edit-icon {
                        opacity: 1;
                    }
                }

                .description-text {
                    font-size: 13px;
                    color: #666;
                    max-width: 400px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .description-placeholder {
                    font-size: 13px;
                    color: #999;
                    font-style: italic;
                }

                .edit-icon {
                    font-size: 14px;
                    color: #999;
                    opacity: 0;
                    transition: opacity 0.2s;
                }
            }
        }

        input {
            background: none;
            border: 0;
            font-size: 22px;
            font-weight: 600;
            line-height: 28px;
            width: 100%;
            font-family: Source Sans Pro, sans-serif;
            cursor: context-menu;
        }
    }

    .representative-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .representative-online {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #00ff00;
            margin-right: 10px;
        }
    }

    .representative-name {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }

    .ant-btn:hover,
    .ant-btn:focus {
        color: #595959;
        background-color: #fff;
        border-color: #d9d9d9;
    }

    .description-edit-modal {
        .modal-actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 15px;
        }
    }
}
</style>
